import { render, staticRenderFns } from "./PropertyPanel.vue?vue&type=template&id=153820f8"
import script from "./PropertyPanel.vue?vue&type=script&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&lang=js"
import style0 from "./PropertyPanel.vue?vue&type=style&index=0&id=153820f8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153820f8')) {
      api.createRecord('153820f8', component.options)
    } else {
      api.reload('153820f8', component.options)
    }
    module.hot.accept("./PropertyPanel.vue?vue&type=template&id=153820f8", function () {
      api.rerender('153820f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flowable/PropertyPanel.vue"
export default component.exports